/**
 * Computes SHA-256 hash of the input string (lowercased).
 * Returns empty string if crypto API unavailable or error occurs.
 * @param {string} input
 * @returns {Promise<string>}
 */
export async function computeSHA256(input) {
    if (typeof window === 'undefined' || !window.crypto || !window.crypto.subtle) {
        return ''
    }
    try {
        const encoder = new TextEncoder()
        const data = encoder.encode(input.toLowerCase())
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', data)
        const hashArray = Array.from(new Uint8Array(hashBuffer))
        return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
    } catch {
        return ''
    }
}

/**
 * Pushes an analytics event to window.dataLayer with common user info and event-specific name.
 * @param {Object} params
 * @param {string} params.eventName - The event name to push
 * @param {string} params.userId - User ID
 * @param {string} params.email - User email
 * @param {boolean} params.registered - Is user registered
 * @param {string} params.phone - User phone number
 * @param {Object} [params.extraData] - Additional event-specific data to merge
 */
export async function pushAnalyticsEvent({
    eventName,
    userId,
    email,
    registered,
    phone,
    extraData = {}
}) {
    if (typeof window === 'undefined' || !window.dataLayer) return

    const sha256 = await computeSHA256(email || '')

    window.dataLayer.push({
        event: eventName,
        userId,
        email: email?.toLowerCase() || '',
        sha256,
        registered,
        phone,
        event_id: `${eventName}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        ...extraData
    })
}
